import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ToastNotification.css'; // Import custom CSS

const ToastNotification = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      closeOnClick
      pauseOnHover
      draggable
      className="toast-container" // Custom CSS class for the container
      toastClassName="toast" // Custom CSS class for each toast
      bodyClassName="toast-body" // Custom CSS class for the toast body
      progressClassName="toast-progress" // Custom CSS class for the progress bar
    />
  );
};

export const showToast = (type, message) => {
  const options = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: 'toast', // Apply custom class to each toast
    bodyClassName: 'toast-body', // Apply custom class to the toast body
    progressClassName: 'toast-progress', // Apply custom class to the progress bar
    toastId: Date.now(),
  }

  switch (type) {
    case "success":
      toast.success(message, options);
      break;
    case "error":
      toast.error(message, options);
      break;
    case "info":
      toast.info(message, options);
      break;
    case "warning":
      toast.warning(message, options);
      break;
    default:
      toast(message, options);
  }
};

export default ToastNotification;